import { render, staticRenderFns } from "./ns-message-action.vue?vue&type=template&id=5a9e4868&scoped=true&"
import script from "./ns-message-action.vue?vue&type=script&lang=js&"
export * from "./ns-message-action.vue?vue&type=script&lang=js&"
import style0 from "./ns-message-action.vue?vue&type=style&index=0&id=5a9e4868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e4868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9e4868')) {
      api.createRecord('5a9e4868', component.options)
    } else {
      api.reload('5a9e4868', component.options)
    }
    module.hot.accept("./ns-message-action.vue?vue&type=template&id=5a9e4868&scoped=true&", function () {
      api.rerender('5a9e4868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-message-action/ns-message-action.vue"
export default component.exports